import React, { Component } from "react";
import cookie from "react-cookies";

import NavbarPage from "../../components/Navbar/Navbar_Page";
import PlatformExperienceNotice from "./PlatformExperienceNotice";
import Section from "../../pages/product-landing";
import Footer from "../Footer/footer";

class ProtectedSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      "session-id-qt": cookie.load("session-id-qt"),
    };
  }

  render() {
    const freeRoutes = [
      "/product",
      "/login",
      "/profile-completion",
      "/signup",
      "/terms",
      "/privacy",
      "/about",
      "/howitworks",
      "/contact",
      "/support",
      "/api-docs",
      "/docs",
      "/partner-api-docs",
      "/enterprise-api-docs",
      "/team/accept",
    ];
    const navBarRoutes = [
      "/dashboard",
      "/book/multi-stop",
      "/route-set",
      "/billing",
      "/settings",
      "/profile",
      "/team",
      "/integrations",
      "/partner-plans",
      "/developers",
      "/widget",
    ];
    const isFreeRoute =
      freeRoutes.includes(window.location.pathname) ||
      window.location.pathname.startsWith("/team/accept");
    const isNavBarRoute = navBarRoutes.some(
      (route) =>
        window.location.pathname === route ||
        (route === "/route-set" && window.location.pathname.startsWith("/route-set/"))
    );
    const isLoggedIn = typeof this.state["session-id-qt"] !== "undefined";
    const showLoginGate = !isFreeRoute && !isLoggedIn;
    const landingShellRoutes = ["/login", "/product"];
    const isLandingShell = landingShellRoutes.includes(window.location.pathname);
    const showAppFooter = !showLoginGate && !isLandingShell;

    return (
      <>
        <PlatformExperienceNotice />
        {isNavBarRoute && isLoggedIn && <NavbarPage />}
        {isFreeRoute ? (
          this.props.children
        ) : isLoggedIn ? (
          this.props.children
        ) : (
          <Section />
        )}
        {showAppFooter ? <Footer /> : null}
      </>
    );
  }
}

export default ProtectedSection;
